<template>
    <el-dialog
            :title="titleName"
            :visible.sync="dialogFormVisible"
            width="44%"
            class="diccss"
    >
        <el-form :model="form" :rules="rules" ref="ruleForm">
            <el-input v-model="form.id" autocomplete="off" style="display: none;"></el-input>

            <el-row>
                <el-col :span="12">
                    <el-form-item label="证字" :label-width="formLabelWidth" :required="true" prop="pzz">
                        <el-input v-model="form.pzz" autocomplete="off"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="说明" :label-width="formLabelWidth" :required="true" prop="zna">
                        <el-input v-model="form.zna" autocomplete="off"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>

            <el-row>
                <el-col :span="12">
                    <el-form-item label="默认" :label-width="formLabelWidth" :required="true" prop="def">
                        <el-select
                                style="width: 100%"
                                v-model="form.def"
                                clearable>
                            <el-option label="是" value="1"/>
                            <el-option label="否" value="0"/>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="状态" :label-width="formLabelWidth" :required="true" prop="sta">
                        <el-radio-group v-model="form.sta">
                            <el-radio label="0">正常</el-radio>
                            <el-radio label="1">停用</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </el-col>
            </el-row>

        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button size="mini" @click="dialogFormVisible = false">取 消</el-button>
            <el-button size="mini" type="primary" @click="addAndUpdate('ruleForm')">确 定</el-button>
        </div>
    </el-dialog>
</template>

<script>
    export default {
        data() {
            return {
                dialogFormVisible: true,
                url: '',
                titleName: '',
                form: {
                    id: '',
                    zhangTaoId: null,
                    zna: '',
                    pzz: '',
                    def: '0',
                    sta: '0'
                },
                rules: {
                    id: [{required: true, message: '请输入主键', trigger: 'blur'}],
                    zhangTaoId: [{required: true, message: '请输入账套ID', trigger: 'blur'}],
                    zna: [{required: true, message: '请输入凭证字说明', trigger: 'blur'}],
                    pzz: [{required: true, message: '请输入凭证字', trigger: 'blur'}],
                    def: [{required: true, message: '请输入默认', trigger: 'blur'}],
                    sta: [{required: true, message: '请输入状态', trigger: 'blur'}]
                },
                formLabelWidth: '77px'
            };
        },
        methods: {
            int(id) {
                this.$refs['ruleForm'].resetFields();
                this.dialogFormVisible = true;
                this.form.id = '';
                this.form.zhangTaoId = null;
                this.form.zna = '';
                this.form.pzz = '';
                this.form.def = '0';
                this.form.sta = '0';

                if (id == 'add') {
                    this.titleName = "凭证类型-新增";
                    this.url = "/business/fuZhuPzz/save";
                } else {
                    this.titleName = "凭证类型-修改";
                    this.url = "/business/fuZhuPzz/update";
                    this.$httpTAG({
                        url: this.$httpTAG.adornUrl('/business/fuZhuPzz/view'),
                        method: 'post',
                        data: this.$httpTAG.adornData({
                            'id': id
                        })
                    }).then(r => {
                        this.form = r.data.data;
                    }).finally(r => {
                    })
                }
            },
            addAndUpdate(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.$httpTAG({
                            url: this.$httpTAG.adornUrl(this.url),
                            method: 'post',
                            data: this.$httpTAG.adornData({
                                ...this.form
                            })
                        }).then(res => {
                            if (res.data.code == 0) {
                                this.$notify({
                                    title: '操作成功！',
                                    type: 'success',
                                    offset: 600
                                });
                                this.dialogFormVisible = false
                                this.$emit("handleCurrentChange", 1);
                            } else {
                                this.$message({ // 失败
                                    type: 'fail',
                                    message: res.data.msg
                                })
                            }
                        })
                    }
                })
            }
        }
    }
</script>

<style scoped>
    .diccss >>> .el-dialog__body {
        padding: 25px 35px 5px 10px;
    }
</style>
